'use client';

import React from 'react';

function CheckPending() {
  return (
    <svg
      viewBox="0 0 170 170"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      height={100}
      width={100}
    >
      <circle
        cx="85.1353"
        cy="84.7505"
        r="84.2993"
        fill="#FF981E"
        fill-opacity="0.2"
      />
      <circle
        cx="85.1359"
        cy="84.7512"
        r="68.5695"
        fill="#FF981E"
        fill-opacity="0.3"
      />
      <circle
        opacity="0.4"
        cx="85.1343"
        cy="84.7496"
        r="55.2906"
        fill="#FF981E"
        fill-opacity="0.3"
      />
      <circle cx="85.1342" cy="84.7514" r="38.4506" fill="#FF981E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.1367 66.752C75.1956 66.752 67.1367 74.8108 67.1367 84.752C67.1367 94.6932 75.1956 102.752 85.1367 102.752C95.0779 102.752 103.137 94.6932 103.137 84.752C103.137 74.8108 95.0779 66.752 85.1367 66.752ZM62.6367 84.752C62.6367 72.3256 72.7103 62.252 85.1367 62.252C97.5632 62.252 107.637 72.3256 107.637 84.752C107.637 97.1784 97.5632 107.252 85.1367 107.252C72.7103 107.252 62.6367 97.1785 62.6367 84.752ZM85.1367 71.252C86.3794 71.252 87.3867 72.2593 87.3867 73.502V82.502H91.8867C93.1294 82.502 94.1367 83.5093 94.1367 84.752C94.1367 85.9946 93.1294 87.002 91.8867 87.002H85.1367C83.8941 87.002 82.8867 85.9946 82.8867 84.752V73.502C82.8867 72.2593 83.8941 71.252 85.1367 71.252Z"
        fill="white"
      />
    </svg>
  );
}

export default CheckPending;
